// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 982 ? "keycloak-js" : chunkId) + "." + {"787":"199f16e3","982":"f3c9c727"}[chunkId] + ".chunk.js";
};